type LandingPropertyKey =
  | 'utm_source'
  | 'utm_medium'
  | 'utm_campaign'
  | 'utm_content'
  | 'utm_term'
  | 'referrer'
  | 'landing_page';

export type LandingProperties = Partial<Record<LandingPropertyKey, string>>;

interface LandingLocation {
  search: string;
  referrer: string;
  origin: string;
  pathname: string;
}

/** Drops the query string and fragment, which can carry emails, tokens or search terms. */
const toOriginAndPath = (url: string): string => {
  try {
    const { origin, pathname } = new URL(url);
    return `${origin}${pathname}`;
  } catch {
    return '';
  }
};

export const getLandingProperties = ({
  search,
  referrer,
  origin,
  pathname
}: LandingLocation): LandingProperties => {
  const params = new URLSearchParams(search);
  const values: Record<LandingPropertyKey, string> = {
    utm_source: params.get('utm_source') ?? '',
    utm_medium: params.get('utm_medium') ?? '',
    utm_campaign: params.get('utm_campaign') ?? '',
    utm_content: params.get('utm_content') ?? '',
    utm_term: params.get('utm_term') ?? '',
    referrer: toOriginAndPath(referrer),
    landing_page: `${origin}${pathname}`
  };
  return Object.fromEntries(
    Object.entries(values).filter(([, value]) => value !== '')
  );
};
